require([
    "common/alertMessage"
],
    function (alertMessage) {

        const changePasswordLinkSelector = ".user-account-top-menu a.change-password-link";
        const changePasswordMessageName = "Login And Registration/Change Password";

        function init() {
            // Delegated on purpose: LinksMenu.js copies the account menu into the mobile menu after page
            // load, so the link exists twice and the second copy doesn't exist yet when this runs.
            $(document).off("click", changePasswordLinkSelector)
                       .on("click", changePasswordLinkSelector, changePasswordClicked);
        }

        // Entra has no change-password screen of its own - the user has to use the password reset link on
        // the Entra sign-in page, which isn't obvious. Explain that first, and go there when they confirm.
        function changePasswordClicked(event) {
            event.preventDefault();
            var url = $(this).attr("href");
            var message = CP.Messages[changePasswordMessageName];
            if (!message) {
                // message not set up in Sitecore - don't trap the user, just carry on to Entra
                console.log("No message found for " + changePasswordMessageName);
                window.location.href = url;
                return;
            }
            alertMessage.info(message, function () { window.location.href = url; });
        }

        init();
    });

define("SiteHeader/main", function(){});

